/**
 * White-label overrides for club crests. See CIP-4607.
 *
 * Stats Insider is not licensed to display the official marks of some clubs, so
 * a site-specific crest is published alongside the shared one on the CDN with a
 * suffixed filename - `RACS_si.svg` next to `RACS.svg`. Clubs listed in
 * `environment.customLogoTeams` load the suffixed file; every other club, and
 * every other build, is untouched.
 *
 * The map is keyed by sport code (abbreviations collide across competitions -
 * `VIL` is Aston Villa in EPL and Villarreal in ESP), then by the team's logo
 * key, which is `sport.jerseyFileKey` - "Abv" for both EPL and ESP.
 */
export type TeamLogoOverrideMap = Record<string, Array<string>>;

/**
 * Filename suffix to append to a club's logo key, e.g. "_si" so that `RACS`
 * resolves to `RACS_si.svg`. Returns "" for clubs that use the shared file.
 */
export function teamLogoFileSuffix(
	customLogoTeams: TeamLogoOverrideMap | undefined,
	customLogoSuffix: string | undefined,
	sportCode: string | undefined | null,
	teamLogoKey: string | number | undefined | null
): string {
	if (!customLogoSuffix || !sportCode || !teamLogoKey) return "";
	const teams = (customLogoTeams || {})[String(sportCode).toUpperCase()];
	if (!teams) return "";
	return teams.includes(String(teamLogoKey).toUpperCase()) ? customLogoSuffix : "";
}
